/* eslint-disable react/forbid-prop-types */
import React from 'react'
import { any } from 'prop-types'
import { Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import { usePermission } from '@fs/zion-permissions'
import LoadingSpinner from '../shared/components/LoadingSpinner'

/**
 * Admits anyone holding the Discovery asset admin permission or the Discovery database admin
 * permission - the same pair the common service's `/admin/**` rule accepts.
 */
export default function AssetOrDatabasePermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  const { signedIn, userLoading } = useUser()

  const [hasAssetPermission, assetStatus] = usePermission('DiscoveryAssetPermission', 'DiscoveryAdminAssetContext')
  const [hasDatabaseAdminPermission, databaseAdminStatus] = usePermission(
    'DiscoveryDatabasePermission',
    'DiscoveryAdminDatabaseContext'
  )

  // usePermission starts out [false, 'loading'], so rendering off the boolean alone flashes the
  // Unauthorized fallback for permitted users. Wait for both checks to settle first.
  const permissionsLoading = [assetStatus, databaseAdminStatus].includes('loading')
  const hasPermission = Boolean(hasAssetPermission || hasDatabaseAdminPermission)
  const loading = userLoading || permissionsLoading

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <>
          {loading && <LoadingSpinner size="lg" />}
          {!loading && signedIn && hasPermission && <Component {...props} />}
          {!loading && (!signedIn || !hasPermission) && <Fallback {...props} />}
        </>
      )}
      requirePersonalData={requirePersonalData}
    >
      {children}
    </Route>
  )
}

AssetOrDatabasePermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
